export default "__VITE_ASSET__5486542a__"